export type NotificationType = 'sms' | 'email' | 'whatsapp' | string;

export const getType = (type: NotificationType): string => {
  switch (type) {
    case 'sms':
      return 'סמס';
    case 'email':
      return 'מייל';
    case 'whatsapp':
      return 'וואטסאפ';
    default:
      return type || '';
  }
};